import React, { Component } from 'react';
import {
  Button,
  FormGroup, Label,
  Input,
  Row, Col,
  Card, CardBody
} from 'reactstrap';
import { messages } from '../../constants/constant.message';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
const { INVALID_ALTERNATE_NO, INVALID_WHATSAPP_NO,
  EMPTY_WHATSAPP_NO, EMPTY_ALTERNATE_NO, EMPTY_PERSON_NAME, EMPTY_DESIGNATION, INVALID_ALTERNATE_EMAIL, EMPTY_ALTERNATE_EMAIL,
} = messages.PROFILE;

class EditPrimaryContactDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    }
  }
  handleOnCancel = () => {
    this.props.onCancel('isContactEditActive', false);
  }

  setLoading = (isLoading) => {
    this.setState({
      isLoading: isLoading
    })
  }
  render() {
    const { primaryPerson, primaryDesignation, primaryNumber, primaryWa, primaryEmail, sameAsUser, setSameAsUserCheckBoxValue } = this.props;

    return <Card className={this.props.className}>
      {this.state.isLoading && <CustomSpinner />}
      <CardBody>
        <Row>
          <Col>
            <b className="margin-right-16">PRIMARY CONTACT DETAILS</b>
            <FormGroup check>
              {/* <Label check>
                <Input
                  type="checkbox"
                  name="checkbox"
                  id="checkbox"
                  checked={sameAsUser}
                  onChange={setSameAsUserCheckBoxValue}
                />{' '}
                Same as owner
              </Label> */}
              <label className="custom-checkboax1--container">
                <input type="checkbox" name="same_as_business" checked={sameAsUser}
                  onChange={setSameAsUserCheckBoxValue}
                />
                <span className="checkmark1" />
              </label>&nbsp;&nbsp;Same As Owner
            </FormGroup>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="primaryPerson">Contact Person<span className="required-field">*</span></Label>
              <Input
                type="text"
                name="primaryPerson"
                id="primaryPerson"
                value={primaryPerson.value}
                // value={null}
                // disabled={sameAsUser}
                onChange={this.props.handleInputChange}
                onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'contact') : null}
                placeholder="Type here" />
              {primaryPerson.showErrorMsg && <div className="error">* {EMPTY_PERSON_NAME}</div>}
            </FormGroup>
          </Col>

          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="primaryNumber">Contact Number<span className="required-field">*</span></Label>
              <Input
                type="text"
                name="primaryNumber"
                id="primaryNumber"
                // disabled={sameAsUser}
                value={primaryNumber.value}
                maxLength="10"
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {primaryNumber.showErrorMsg && primaryNumber.invalidPhone && <div className="error">* {INVALID_ALTERNATE_NO}</div>}
              {primaryNumber.showErrorMsg && primaryNumber.nullValue && <div className="error">* {EMPTY_ALTERNATE_NO}</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="primaryEmail">Email Address<span className="required-field">*</span></Label>
              <Input
                type="text"
                name="primaryEmail"
                id="primaryEmail"
                // disabled={sameAsUser}
                value={primaryEmail.value}
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {primaryEmail.showErrorMsg && primaryEmail.invalidEmail && <div className="error">* {INVALID_ALTERNATE_EMAIL}</div>}
              {primaryEmail.showErrorMsg && primaryEmail.nullValue && <div className="error">* {EMPTY_ALTERNATE_EMAIL}</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="primaryWa">Whatsapp Number <span className="required-field">*</span></Label>
              <Input
                type="text"
                name="primaryWa"
                id="primaryWa"
                // ref={(input) => { this.textInput = input; }}
                // autoFocus={true}
                autoFocus={primaryWa.autoFocus}
                // disabled={sameAsUser}
                value={primaryWa.value}
                maxLength="10"
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {primaryWa.showErrorMsg && primaryWa.invalidPhone && <div className="error">* {INVALID_WHATSAPP_NO}</div>}
              {primaryWa.showErrorMsg && primaryWa.nullValue && <div className="error">* {EMPTY_WHATSAPP_NO}</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="primaryDesignation">Designation<span className="required-field">*</span></Label>
              <Input
                type="text"
                name="primaryDesignation"
                id="primaryDesignation"
                // disabled={sameAsUser}
                value={primaryDesignation.value}
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {primaryDesignation.showErrorMsg && <div className="error">* {EMPTY_DESIGNATION}</div>}

            </FormGroup>
          </Col>
        </Row>
        {this.props.onSave && <Row>
          <Col xl="12" xs="12" md="12" className="text-align-right" >
            <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={this.handleOnCancel}>Cancel</Button>
            <Button className="mb-1 mr-1 btn-pill action-button profile-save-button" color="warning" onClick={this.props.onSave}>Save</Button>
          </Col>
        </Row>}
      </CardBody>
    </Card >;
  }
}

export default EditPrimaryContactDetail;
